<template>
    <div>Redirecting...</div>
</template>
<script>

export default {
  created() {
    if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
      window.location = 'https://apps.apple.com/us/app/id1528104216';
    } else if (navigator.userAgent.match(/android/i)) {
      window.location = 'https://play.google.com/store/apps/details?id=ph.com.nineonesevenventures.healthnow';
    } else {
      window.location = 'https://www.healthnow.ph';
    }
  },
};
</script>
